import { Box, CssBaseline, Grid } from "@mui/material";

import Container from "../../components/custom/Container";
import GlobalStyle from "../../components/GlobalStyle";
import MobileNavBar from "../../components/custom/MobileNavBar";
import { Outlet } from "react-router-dom";
import PersonalMenu from "../../components/custom/PersonalMenu";
import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import bg from "../../assets/bgs/kindle.jpg";
import dashboardItems from "../../components/sidebar/dashboardItems";

import styled from "styled-components/macro";
import PublisherSelectionDialog from "../../components/custom/PublisherSelectionDialog";

const drawerWidth = `6.375rem`;

const Root = styled.div`
  background-image: url(${bg});

  background: linear-gradient(
      ${(props) => props.theme.palette.authBg.background},
      ${(props) => props.theme.palette.authBg.background}
    ),
    url(${bg});
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: ${(props) => props.theme.spacing(3)};
    padding-bottom: ${(props) => props.theme.spacing(3)};
    padding-left: ${(props) => props.theme.spacing(3)};
    padding-right: ${(props) => props.theme.spacing(3)};
  }
  padding-top: ${(props) => props.theme.spacing(3)};
  padding-bottom: ${(props) => props.theme.spacing(3)};
  padding-left: ${(props) => props.theme.spacing(10)};
  padding-right: ${(props) => props.theme.spacing(10)};

  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

const StyledContainer = styled(Container)`
  ${(props) => props.theme.breakpoints.down("md")} {
    margin-bottom: 3rem;
  }
`;

const Drawer = styled.div`
  height: 100%;

  ${(props) => props.theme.breakpoints.up("sm")} {
    //width: ${drawerWidth};
    flex-shrink: 0;
  }
`;

const AppContent = styled(Box)`
  flex: 1;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  height: 94vh;

  ${(props) => props.theme.breakpoints.down("md")} {
    overflow-y: hidden;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-button {
    // width: 50px; //for horizontal scrollbar
    height: 12px; //for vertical scrollbar
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
  }
`;

const StyledGridContainer = styled(Grid)`
  height: 100%;
`;

const StyledGridItem = styled(Grid)``;

const Dashboard = ({ children }) => {
  // const { data: addonsData } = useQuery("latestAddons", getAddons);
  //const { data: messagesData } = useQuery("latestMessages", getLatestMessages);
  // const [{ state }] = useAuth();
  // const { user } = state;
  const publisherName = window?.sessionStorage?.getItem("publisherName");
  const [user, setUser] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const setDataFromLocalStorage = () => {
    try {
      const user = JSON.parse(window?.sessionStorage?.getItem("user"));
      const selectedPublisherId = JSON.parse(
        window.sessionStorage.getItem("selectedPublisherId")
      );
      setUser(user);
      setIsAdmin(user?.role?.description.toLowerCase() === "admin");
      // evaluates starting as true if the role is admin and hasn't selected a publisher id
      // otherwise it shouldn't open on dashboard
      setIsDialogOpen(
        user?.role?.description.toLowerCase() === "admin" &&
          !selectedPublisherId
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setDataFromLocalStorage();
  }, []);

  return (
    <Root>
      <StyledContainer>
        <CssBaseline />
        <GlobalStyle />
        <MobileNavBar />
        <StyledGridContainer
          container
          justifyContent="flex-between"
          spacing={0}
          direction="row"
          wrap="nowrap"
        >
          <StyledGridItem
            item
            xs="auto"
            sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          >
            <Drawer>
              <Box
                sx={{
                  height: "100%",
                }}
              >
                <Sidebar
                  PaperProps={{ style: { width: drawerWidth } }}
                  items={dashboardItems}
                />
              </Box>
            </Drawer>
          </StyledGridItem>
          <Grid
            container
            item
            direction="row"
            style={{ overflow: "auto", maxWidth: "100%", overflowX: "hidden" }}
          >
            <StyledGridItem
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ display: { xs: "none", md: "block" } }}
            >
              <PersonalMenu
                userDetails={{
                  fullName: user?.firstName + " " + user?.lastName,
                  publisherName: publisherName,
                  roleType: user?.role?.description,
                }}
                addons={[]}
                messages={[]}
              />
            </StyledGridItem>
            <StyledGridItem
              item
              container
              xs={12}
              md={12}
              lg={12}
              justifyContent="center"
            >
              <AppContent>
                {children}
                <Outlet />
              </AppContent>
            </StyledGridItem>
          </Grid>
        </StyledGridContainer>
        {/* <Settings /> */}
      </StyledContainer>
      {isAdmin && (
        <PublisherSelectionDialog
          isDialogOpen={isDialogOpen}
          isAdmin={isAdmin}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}
    </Root>
  );
};

export default Dashboard;
